import { createSlice } from '@reduxjs/toolkit';
import { login, logout, recoveryUser, refreshUser, register, resetPassword } from './operations';

const initialState = {
  isLoggedIn: false,
  isRefreshing: true,
};

const handlePending = state => {
  state.isRefreshing = true;
  state.error = null;
};
const handleRejected = (state, action) => {  
  state.isRefreshing = false;
  state.isLoggedIn = false;

  state.error = action.payload;
};
const handleFulfilled = (state, action) => {
  state.isRefreshing = false;
  state.isLoggedIn = true;
  state.error = null;

  const { role, name } = action.payload;
  state.user = { role, name };
  state.token = action.payload.token;
};
const handleLogout = state => {
  state.isRefreshing = false;
  state.isLoggedIn = false;
  delete state.user;
  delete state.token;
};

export const authSlise = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) =>
    builder
      .addCase(register.pending, (state) => handlePending(state))
      .addCase(register.fulfilled, (state, action) => {
        // handleFulfilled(state, action)
        state.isRefreshing = false;
        state.error = null;
        alert(action?.payload?.message || 'Реєстрація пройшла успішно! Зверніться до адміністратора, щоб активувати акаунт.');
      })
      .addCase(register.rejected, (state, action) => {
        alert(action?.payload?.message || 'Внутрішня помилка сервера');
        handleRejected(state, action)
      })
      .addCase(login.pending, (state) => handlePending(state))
      .addCase(login.fulfilled, (state, action) => handleFulfilled(state, action))
      .addCase(login.rejected, (state, action) => {
        alert(action?.payload?.message || 'Внутрішня помилка сервера');
        handleRejected(state, action)
      })
      .addCase(refreshUser.pending, (state) => handlePending(state))
      .addCase(refreshUser.fulfilled, (state, action) => handleFulfilled(state, action))
      .addCase(refreshUser.rejected, (state, action) => handleLogout(state, action))

      .addCase(logout.pending, (state) => handlePending(state))
      .addCase(logout.fulfilled, state => handleLogout(state))
      .addCase(logout.rejected, (state, action) => handleRejected(state, action))

      .addCase(recoveryUser.pending, (state) => handlePending(state))
      .addCase(recoveryUser.fulfilled, (state, action) => { 
        state.isRefreshing = false;
        state.recovery = true;
        alert(action?.payload?.message || 'Перевірте свій email для відновлення паролю'); 
      })
      .addCase(recoveryUser.rejected, (state, action) => { 
        state.isRefreshing = false;
        state.recovery = null;
        alert(action?.payload?.message || 'Внутрішня помилка сервера'); 
      })
      .addCase(resetPassword.pending, (state) => handlePending(state))
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isRefreshing = false;
        state.reset = true;
        alert(action?.payload?.message || 'Пароль успішно змінено');
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isRefreshing = false;
        state.reset = null;
        alert(action?.payload?.message || 'Внутрішня помилка сервера'); 
      }),
});

export const { setIsRefreshing } = authSlise.actions;
export const authReducer = authSlise.reducer;
